const locale = require('./collaboration.i18n.json');

/*@ngInject*/
const CollaborationController = function ($scope, $rootScope, $timeout, $state, $stateParams, $location, $uibModal, $window, coreConstant, uiPerformanceLoggerConstant, submissionConstant, submissionStateMediator, coreMediator, dateUtil, authorizationConstants, emailMessageStatus, submissionTaskStatus, attachmentUtil, collaborationMediator, attachmentMediator, modalUtil, currentUserModel, collaborationUtil, preferenceModel) {

    let timeoutList = [];

    $scope.i18n = locale;

    $scope.viewModel = {
        isOpen: false,
        isLoading: false,
        filterType: 'all',
        isSearchOpen: false,
        searchInput: '',
        searchDelayInMilliSeconds: submissionConstant.searchDelay,
        collabItemList: [],
        currentUserId: 0,
        selectedItem: null,
        chat: {
            isVisible: false
        },
        note: {
            isVisible: false,
            isEditorSaving: false
        },
        email: {
            isVisible: false,
            isEditorOpen: false,
            isEditorSaving: false
        },
        attachment: {
            isVisible: false,
            isEditorOpen: false,
            isEditorSaving: false
        },
        task: {
            isVisible: false,
            isEditorOpen: false,
            isEditorSaving: false
        },
        permissions: [],
        preferenceDateFormat: null,
        userType: null,
        showGearIcon: false,
        hasSharedPermission: false,
        enableEmailFromTemplate: false,
        enableFileFromTemplate: false,
        filterList: [],
        filterListItemName: 'name',
        collabItemsCopy: [],
        isFilterOn: false,
        selectedFilterList: [],
        initialSelectedFilter: [],
        currentSelectedTab: '',
        isTaskResolutionReasonEnabled: false,
        isTaskReceivedDateEnabled: false,
        isRefreshCollaborationAttachmentsEnabled: false
    };

    this.$onInit = function () {
        attachmentUtil.getAttachmentTypes().then(function (result) {
            $scope.viewModel.filterList = result;
        });

        $scope.viewModel.isPrintingCollab = $state.current.name === 'submission.printCollaboration';

        if($stateParams.collabType) {
            $scope.viewModel.title = $scope.i18n.printTitle[$stateParams.collabType];
            $scope.onCollaborationFilterClick($stateParams.collabType);
            openDrawer();
            if ($stateParams.collabId) {
              $scope.selectItem({type: $stateParams.collabType, id: $stateParams.collabId});
            }
        }
        else {
            $scope.viewModel.title = $scope.i18n.title;
        }

        $scope.viewModel.isTaskResolutionReasonEnabled = preferenceModel.get('system.enableTaskResolutionReason') === 'true';
        $scope.viewModel.isTaskReceivedDateEnabled = preferenceModel.get('system.enableTaskReceivedDate') === 'true';
        $scope.viewModel.isRefreshCollaborationAttachmentsEnabled = preferenceModel.get('system.enableRefreshCollaborationAttachments') === 'true';
    };

    $scope.onCollaborationFilterClick = function (type) {
        $scope.viewModel.filterType = type;
        if ($scope.viewModel.currentSelectedTab === '' || $scope.viewModel.currentSelectedTab !== type) {
            loadCollaboration();
            setSelectedItem();
        }
        $scope.viewModel.currentSelectedTab = type;
    };

    $scope.getUserFullName = function (collabItem) {
        return collabItem.userFullName === 'AUTHENTICATION_SERVER' ? 'System' : collabItem.userFullName;
    };

    function filterItem() {
        let filterList = [];
        if ($scope.viewModel.selectedFilterList.length > 0) {
            _.each($scope.viewModel.collabItemsCopy, function (collabItem) {
                _.each($scope.viewModel.selectedFilterList, function (selectedItem) {
                    if (collabItem.summaryData.collaborationType === selectedItem.name) {
                        filterList.push(collabItem);
                    }
                });
            });
            $scope.viewModel.collabItemList = filterList;
        } else {
            $scope.viewModel.collabItemList = $scope.viewModel.collabItemsCopy;
        }

    }

    function setSelectedItem() {
        let initialSelectedItems = [];

        _.each($scope.viewModel.filterList, function (item) {
            _.each($scope.viewModel.selectedFilterList, function (selectedItem) {
                if (item.name === selectedItem.name) {
                    initialSelectedItems.push(item.name);
                }
            });
        });
        $scope.viewModel.initialSelectedFilter = _.join(initialSelectedItems, '::');
    }

    function loadCollaboration() {
        let collabType = $stateParams.collabType,
            collabId = $stateParams.collabId;
        loadCollaborationItems().then(function () {
            $rootScope.$broadcast(submissionConstant.event.COLLABORATION_FILTER_CHANGE, $scope.viewModel.filterType);

            $scope.closeNoteEditor();
            if (collabType && collabId) {
              $scope.selectItem({type: collabType, id: collabId});
            }

            saveState();

            if ($scope.viewModel.filterType.toLowerCase() === 'task') {
                sortCollabTaskList();
            } else {
                sortCollabItemList();
            }

            if ($scope.viewModel.filterType !== 'chat' && $scope.viewModel.filterType !== 'task') {
                filterItem();
            }
        });
    }

    $scope.getSearchPlaceholder = function () {
        return $scope.i18n.searchPlaceholder;
    };

    function resetSearch() {
        if ($scope.viewModel.searchInput && $scope.viewModel.searchInput !== '') {
            $scope.viewModel.searchInput = '';
            loadCollaborationItems();
        }
        $scope.viewModel.isSearchOpen = false;
    }

    function saveState() {
        let toOmit = [
            'collabItemList',
            'isLoading',
            'permissions',
            'note.isEditorSaving',
            'attachment.isEditorSaving',
            'task.isEditorSaving',
            'userType'
        ];

        submissionStateMediator.saveCollaborationState($stateParams.submissionId, _.omit($scope.viewModel, toOmit));
    }

    function loadCollaborationItems() {
        let index;
        if (!_.isNil($stateParams.submissionId)) {
            $scope.viewModel.collabItemList = [];
            $scope.viewModel.isLoading = true;

            return collaborationMediator.loadCollaborationItems($stateParams.submissionId, $scope.viewModel.searchInput).then(function (collabItems) {
                _.each(collabItems, function (collabItem) {
                    if (collabItem.type === $scope.viewModel.filterType || $scope.viewModel.filterType === 'all') {
                        index = _.findIndex($scope.viewModel.collabItemList, function (collaborationItem) {
                            return collabItem.uri === collaborationItem.uri;
                        });

                        if(index === -1){
                            $scope.viewModel.collabItemList.push(collabItem);
                        }
                    }
                });
                processCollaborationItems();
                if ($scope.viewModel.filterType !== 'chat' && $scope.viewModel.filterType !== 'task') {
                    filterItem();
                }
            }).finally(function () {
                $scope.viewModel.isLoading = false;
            });
        }
    }

    function getFileTemplates() {
        coreMediator.getRemoteDataSetByName('File Templates').then(function (dataSet) {
            $scope.viewModel.enableFileFromTemplate = dataSet.items.length > 0;
        });
    }

    function getEmailTemplates() {
        coreMediator.getRemoteDataSetByName('Email Templates').then(function (dataSet) {
            $scope.viewModel.enableEmailFromTemplate = dataSet.items.length > 0;
        });
    }

    function generateNoteSnippet(collabItem) {
        let snippet = '';

        // only run it if string might be too long
        if(!_.isNil(collabItem.summaryData.note)) {
            if (collabItem.summaryData.note.length > 200) {
                if (_.indexOf(collabItem.summaryData.note, ' ') === -1) {
                    //make sure we have at least one space to cut of the text
                    snippet = collabItem.summaryData.note.substring(0, 200) + ' ' + collabItem.summaryData.note.substring(200, collabItem.summaryData.note.length);
                }
            }

            if (!snippet) {
                snippet = collabItem.summaryData.note;
            }
        }

        return snippet;
    }

    function processCollaborationItems() {
        let showGearIcon = false;
        _.map($scope.viewModel.collabItemList, function (collabItem) {
            collabItem.type = collabItem.type.toLowerCase();
            let fullDate = dateUtil.formatShortDate(collabItem.lastModified);
            let fullDateArr = _.split(fullDate, ' ');
            collabItem.date = fullDateArr[0];
            collabItem.time = dateUtil.formatTime(collabItem.lastModified).toUpperCase();
            if (collabItem.type === 'note') {
                collabItem.summaryData.snippet = generateNoteSnippet(collabItem);
                collabItem.summaryData.note = collabItem.summaryData.note;
            } else if (collabItem.type === 'attachment') {
                let fileType = collabItem.summaryData.name.split('.');
                if (fileType.length > 1) {
                    collabItem.fileType = fileType.pop();
                }
            }

            if ($scope.viewModel.hasSharedPermission && !_.isNil(collabItem.summaryData)) {
                if (collabItem.summaryData.publicNote || collabItem.summaryData.shared) {
                    showGearIcon = true;
                }
            }

            return collabItem;
        });

        $scope.viewModel.showGearIcon = showGearIcon;

        if (_.toLower($scope.viewModel.filterType) === 'task') {
            sortCollabTaskList();
        } else {
            sortCollabItemList();
        }
        $scope.viewModel.collabItemsCopy = _.map($scope.viewModel.collabItemList, _.clone);
    }

    function loadProfileInfo() {
        coreMediator.loadUserProfile().then(function (userProfile) {
            $scope.viewModel.currentUserId = userProfile.userId;
            $scope.viewModel.userProfile = userProfile;
            $scope.viewModel.userType = userProfile.userType;

            let permissions = [],
                neededPermissions = [
                    authorizationConstants.AUTHORIZATION_ADD_MODIFY_NOTES,
                    authorizationConstants.AUTHORIZATION_DELETE_NOTES,
                    authorizationConstants.AUTHORIZATION_SHARE_UNSHARE_NOTES,
                    authorizationConstants.AUTHORIZATION_MODIFY_OTHER_USERS_NOTE_OPTIONS,
                    authorizationConstants.AUTHORIZATION_ADD_ATTACHMENTS,
                    authorizationConstants.TASK_ADD_MODIFY,
                    authorizationConstants.TASK_DELETE,
                    authorizationConstants.SEND_EMAIL,
                    authorizationConstants.AUTHORIZATION_EMAIL_DELETE_EMAIL,
                    authorizationConstants.AUTHORIZATION_EMAIL_VIEW_PRIVATE_EMAIL,
                    authorizationConstants.AUTHORIZATION_HIDE_SHARED_EMAIL,
                    authorizationConstants.AUTHORIZATION_MODIFY_ATTACHMENTS,
                    authorizationConstants.LIVE_CHAT
                ];

            _.each(neededPermissions, function (neededPermission) {
                if (currentUserModel.hasAuthorization(neededPermission)) {
                    permissions.push(neededPermission);
                }
            });

            $scope.viewModel.permissions = permissions;

            if ($scope.canHideEmail() && $scope.canEditNoteShare() && $scope.canEditAttachment()) {
                $scope.viewModel.hasSharedPermission = true;
            }

        });

        if (coreMediator.getPreferenceByName('view.shortDateFormat')) {
            $scope.viewModel.preferenceDateFormat = updateFormatForDatepicker(coreMediator.getPreferenceByName('view.shortDateFormat'));
        }
    }

    function sortCollabItemList() {
        $scope.viewModel.collabItemList = _.sortBy($scope.viewModel.collabItemList, function (item) {
            return item.lastModified;
        }).reverse();

        _.remove($scope.viewModel.collabItemList, function (item) {
            return item.type === 'header';
        });
    }

    function sortCollabTaskList() {
        let resolutionDateFirstIndex;

        $scope.viewModel.collabItemList = _.orderBy($scope.viewModel.collabItemList, ['summaryData.status', 'lastModified'], ['asc', 'desc']);

        _.remove($scope.viewModel.collabItemList, function (item) {
            return item.type.toLowerCase() === 'header';
        });

        resolutionDateFirstIndex = _.findIndex($scope.viewModel.collabItemList, function (item) {
            return item.type.toLowerCase() === 'task' && item.summaryData.status === submissionTaskStatus.RESOLVED;
        });

        if (resolutionDateFirstIndex > -1) {
            $scope.viewModel.collabItemList.splice(resolutionDateFirstIndex, 0, {type: 'header'});
        }
    }

    function openDrawer() {
        $scope.viewModel.isOpen = true;
        saveState();
        $rootScope.$broadcast(submissionConstant.event.COLLABORATION_DID_OPEN);
    }

    function closeDrawer() {
        $scope.viewModel.isOpen = false;
        saveState();
        $rootScope.$broadcast(submissionConstant.event.COLLABORATION_DID_CLOSE);
    }

    function restoreState() {
        let savedViewModel = submissionStateMediator.getCollaborationState($stateParams.submissionId);

        if (savedViewModel) {
            $scope.viewModel = _.extend($scope.viewModel, savedViewModel);

            if ($scope.viewModel.isOpen) {
                $rootScope.$broadcast(submissionConstant.event.COLLABORATION_DID_OPEN);
            }
        }
    }

    function updateFormatForDatepicker(dateFormat) {
        return _.replace(dateFormat.toLowerCase(), 'mm', 'MM');
    }

    $scope.attachmentDownloadClick = ($event, collabItem) => {
        $event.stopPropagation();
        attachmentUtil.getAttachmentLinkURL(collabItem.id, collabItem.summaryData.name).then((url) => {
            $window.open(url, '_blank');
        });
    };

    $scope.showEmail = function (collabType) {
        if (collabType === 'email') {
            if ($scope.viewModel.userType === 'Underwriter' || $scope.viewModel.userType === 'ServiceUser') {
                return preferenceModel.get('system.enableEmailCollaborationForUnderwriterWorkstation') === 'true';
            } else if ($scope.viewModel.userType === 'Agent') {
                return preferenceModel.get('system.enableEmailCollaborationForAgentWorkspace') === 'true';
            }
        } else {
            return true;
        }
    };

    $scope.isPrintingCollab = function () {
        return $state.current.name === 'submission.printCollaboration';
    };

    $scope.onToggleCollaboration = function () {
        return !$scope.viewModel.isOpen ? openDrawer() : closeDrawer();
    };

    $scope.hasAvatar = function (index) {
        return typeof $scope.viewModel.collabItemList[index].userAvatar !== 'undefined';
    };

    $scope.isVisible = function (item) {
        return $scope.viewModel.filterType === 'all' ||
            $scope.viewModel.filterType === item.type ||
            $scope.viewModel.filterType === 'task' && item.type === 'header';
    };

    $scope.openCreateNoteEditor = function () {
        $scope.viewModel.selectedItem = {type: 'note'};
        saveState();
    };

    $scope.openTaskEditor = function () {
        $scope.viewModel.task.isVisible = true;
        $scope.viewModel.task.isEditorOpen = true;
        saveState();
    };

    $scope.openAttachmentEditor = function () {
        $scope.viewModel.attachment.isVisible = true;
        $scope.viewModel.attachment.isEditorOpen = true;
        saveState();
        $rootScope.$broadcast(submissionConstant.event.ATTACHMENT_EDITOR_DID_OPEN);
    };

    $scope.openAttachmentFromTemplate = function () {
        collaborationMediator.createCorrespondenceForm($stateParams.submissionId).then(function (correspondenceFormId) {
            if (!_.isNil(correspondenceFormId) && correspondenceFormId !== -1) {
                $uibModal.open({
                    templateUrl: '/collaboration/attachment/fileTemplateModal/fileTemplateModal.tpl.html',
                    controller: 'fileTemplateModalController',
                    windowClass: 'fileTemplateModal',
                    resolve: {
                        submissionId: function () {
                            return $stateParams.submissionId;
                        },
                        correspondenceFormId: function () {
                            return correspondenceFormId;
                        }
                    },
                    keyboard: false,
                    backdrop: 'static'
                });
            }
        });
    };

    $scope.openChat = function () {
        $scope.viewModel.collabItemList = [];
        $scope.viewModel.filterType = 'chat';
        $scope.viewModel.chat.isVisible = true;
        $scope.viewModel.currentSelectedTab = $scope.viewModel.filterType;
        saveState();
    };

    $scope.openEmailEditor = function () {
        $scope.viewModel.email.isVisible = $scope.selectedItem.status !== emailMessageStatus.STATUS_DRAFT;
        $scope.viewModel.email.isEditorOpen = true;
        saveState();
    };

    $scope.closeAttachmentEditor = function () {
        $scope.hideSubPage();
    };

    $scope.saveAttachment = function (data, file) {
        $scope.viewModel.attachment.isEditorSaving = true;
        $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.UPLOAD_ATTACHMENT, $stateParams.submissionId);
        attachmentMediator.saveAttachment(data, file).then(function () {
            $scope.viewModel.attachment.isEditorSaving = false;
            $scope.viewModel.attachment.isEditorOpen = false;
            $scope.viewModel.attachment.isVisible = false;
            resetSearch();
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.UPLOAD_ATTACHMENT, coreConstant.uiPeformanceLogger.SUCCESS);
        }, function () {
            $scope.viewModel.attachment.isEditorSaving = false;
            $scope.viewModel.attachment.isEditorOpen = true;
            $scope.viewModel.attachment.isVisible = true;
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.UPLOAD_ATTACHMENT, coreConstant.uiPeformanceLogger.FAIL);
        }).finally(function () {
            saveState();
        });
    };

    $scope.deleteAttachment = function (attachmentId) {
        attachmentMediator.deleteAttachment(attachmentId).then(function () {
            $scope.hideSubPage();
            resetSearch();
        });
    };

    $scope.updateAttachment = function (attachment) {
        attachmentMediator.updateAttachment(attachment.id, attachment).then(resetSearch);
    };

    $scope.closeNoteEditor = function () {
        $scope.hideSubPage();
        saveState();
    };

    $scope.getTaskDefinition = function (definition) {
        return _.replace(_.replace(definition, 'Other::', ''), 'Other - ', '');
    };

    $scope.createNote = function (data) {
        $scope.viewModel.note.isEditorSaving = true;
        data = _.extend(data, {submissionId: $stateParams.submissionId});

        collaborationMediator.createCollaborationNote(data).then(function () {
            $scope.viewModel.note.isEditorSaving = false;
            $scope.closeNoteEditor();
            resetSearch();
            loadCollaborationItems();
        });
    };

    $scope.updateNote = function (noteId, data) {
        $scope.viewModel.note.isEditorSaving = true;
        data = _.extend(data, {submissionId: $stateParams.submissionId});

        // make sure change is apply until we received the refresh data from the server
        $scope.collabItemList = _.map($scope.collabItemList, function (item) {
            if (item.id === data.id && item.type === 'note') {
                item.text = data.text;
                item.lastModified = new Date();
            }

            return item;
        });

        sortCollabItemList();

        collaborationMediator.updateCollaborationNote(noteId, data).then(function () {
            $scope.viewModel.note.isEditorSaving = false;
            resetSearch();
        });
    };

    $scope.deleteNote = function (noteId) {
        collaborationMediator.deleteCollaborationNote(noteId).then(function () {
            $scope.hideSubPage();
            resetSearch();
        });
    };

    $scope.$on(coreConstant.event.HANDLE_EMAIL_FROM_BUSINESS_CARD, function (event, submissionId, sendMailUserId) {
        $scope.viewModel.sendMailUserId = sendMailUserId;
    });

    $scope.$on(coreConstant.event.SHOW_EMAIL_EDITOR, function (event, draftEmailId, submissionId, chatMessageId, emailMessageId, notificationId, deleteNewEmailOnCancel, isReplyOrForward) {
        if ($stateParams.submissionId === submissionId.toString()) {
            collaborationMediator.loadCollaborationEmail(draftEmailId).then(function (email) {
                email.type = 'email';
                email.deleteNewEmailOnCancel = deleteNewEmailOnCancel;
                email.isReplyOrForward = isReplyOrForward;

                if ($scope.viewModel.sendMailUserId) {
                    email.isOpenedFromBusinessCard = true;
                    /*
                     * UMS-26310
                     * Use the chat-message, email-message, and notification ids in the "GET /User/id" request.
                     * This is step 6 of 6.
                     * The previous step is in the persistentConnection.js:alert function.
                     */
                    coreMediator.loadUserById($scope.viewModel.sendMailUserId,
                                              submissionId,
                                              notificationId,
                                              chatMessageId,
                                              emailMessageId)
                                .then(function (userProfile) {
                        email.summaryData = {
                            emailTo: collaborationUtil.getEmailIdentifierString(userProfile.name, userProfile.emailAddress)
                        };
                        openDrawer();
                        $scope.selectItem(email);
                    });
                } else {
                    timeoutList.push($timeout(function () {
                        openDrawer();
                        $scope.selectItem(email);
                    }, 0));
                }
            });
        }
    });

    $scope.createGenericCorrespondenceEmail = function () {
        let isCustomEmailNotification = true;
        coreMediator.sendEmailNotification('notification.sendEmailFromEmailCollaborationTool', isCustomEmailNotification, $stateParams.submissionId);
    };

    $scope.createEmail = function () {
        collaborationMediator.createEmailCorrespondenceForm($stateParams.submissionId).then(function (correspondenceFormId) {
            if (!_.isNil(correspondenceFormId) && correspondenceFormId !== -1) {
                $uibModal.open({
                    templateUrl: '/collaboration/email/emailTemplateModal/emailTemplateModal.tpl.html',
                    controller: 'emailTemplateModalController',
                    windowClass: 'emailTemplateModal',
                    resolve: {
                        submissionId: function () {
                            return $stateParams.submissionId;
                        },
                        correspondenceFormId: function () {
                            return correspondenceFormId;
                        }
                    },
                    keyboard: false,
                    backdrop: 'static'
                }).result.then(resetSearch);
            } else {
                coreMediator.sendEmailNotification('notification.sendEmailFromEmailCollaborationTool', /*isCustom=*/true, $stateParams.submissionId).then(resetSearch);
            }
        });
    };

    $scope.closeTaskEditor = function () {
        $scope.viewModel.task.isEditorOpen = false;
        saveState();
    };

    $scope.createTask = function (data) {
        $scope.viewModel.task.isEditorSaving = true;
        data = _.extend(data, {submissionId: $stateParams.submissionId});

        collaborationMediator.createCollaborationTask(data).then(function () {
            $scope.viewModel.task.isEditorSaving = false;
            $scope.closeTaskEditor();
            resetSearch();
        });
    };

    $scope.updateTask = function (taskId, data) {
        $scope.viewModel.task.isEditorSaving = true;
        data = _.extend(data, {submissionId: $stateParams.submissionId});
        return collaborationMediator.updateCollaborationTask(taskId, data).then(function () {
            $scope.viewModel.task.isEditorSaving = false;
            loadCollaborationItems();
        });
    };

    $scope.deleteTask = function (taskId) {
        collaborationMediator.deleteCollaborationTask(taskId).then(function () {
            $scope.hideSubPage();
            resetSearch();
        });
    };

    $scope.getTotalSeconds = function (date) {
        return dateUtil.getSeconds(date);
    };

    $scope.showCreateDropdown = function () {
        return $scope.viewModel.filterType === 'all';
    };

    $scope.onSelectItem = function (event, item) {
        if (event.target.tagName !== 'A') {
            $scope.selectItem(item);
        }
    };

    $scope.selectItem = function (item) {
        // if we try to open the same item
        if ($scope.viewModel.selectedItem && $scope.viewModel.selectedItem.id === item.id && $scope.viewModel.selectedItem.type === item.type) {
            $scope.viewModel[item.type].isVisible = true;
        } else {
            $scope.viewModel.selectedItem = item;
            if (item.type.toLocaleLowerCase() === 'message') {
                $scope.openChat();
            }
        }
        saveState();
    };

    $scope.hideSubPage = function () {

        $scope.viewModel.chat.isVisible = false;
        $scope.viewModel.email.isVisible = false;
        $scope.viewModel.note.isVisible = false;
        $scope.viewModel.task.isVisible = false;
        $scope.viewModel.attachment.isVisible = false;
        $scope.viewModel.selectedItem = null;
        $scope.viewModel.attachment.isEditorOpen = false;
        $scope.viewModel.email.isEditorOpen = false;
        $scope.viewModel.task.isEditorOpen = false;

        saveState();
    };

    $scope.isTaskPastDue = function (item) {
        if (item && item.summaryData && item.summaryData.dueDate) {
            return dateUtil.isBefore(item.summaryData.dueDate, new Date()) && !item.summaryData.resolutionDate;
        }
    };

    $scope.isUserGroup = function (item) {
        return (item && item.summaryData && item.summaryData.assignedToGroup) ? true : undefined;
    };

    $scope.isEmailDraft = function (item) {
        return (item.type === 'email' && item.summaryData.status === emailMessageStatus.STATUS_DRAFT);
    };


    $scope.isEmailWithAttachment = function (item) {
        return (item.type === 'email' && parseInt(item.summaryData.numAttachments) > 0);
    };

    $scope.isTaskWithAttachment = function (item) {
        return (item.type === 'task' && parseInt(item.summaryData.numAttachments) > 0);
    };

    $scope.getCurrentUser = function () {
        return $scope.viewModel.userProfile;
    };

    $scope.canAssignTask = function () {
        return (_.includes($scope.viewModel.permissions, authorizationConstants.TASK_ADD_MODIFY));
    };

    $scope.canDeleteTask = function () {
        return (_.includes($scope.viewModel.permissions, authorizationConstants.TASK_DELETE));
    };

    $scope.canCreateNote = function () {
        return (_.includes($scope.viewModel.permissions, authorizationConstants.AUTHORIZATION_ADD_MODIFY_NOTES));
    };

    $scope.canEditNoteShare = function () {
        return (_.includes($scope.viewModel.permissions, authorizationConstants.AUTHORIZATION_SHARE_UNSHARE_NOTES));
    };

    $scope.canEditAttachment = function () {
        return (_.includes($scope.viewModel.permissions, authorizationConstants.AUTHORIZATION_MODIFY_ATTACHMENTS));
    };

    $scope.canCreateChat = function () {
        return (_.includes($scope.viewModel.permissions, authorizationConstants.LIVE_CHAT));
    };

    $scope.canCreateEmail = function () {
        return (_.includes($scope.viewModel.permissions, authorizationConstants.SEND_EMAIL));
    };

    $scope.canDeleteEmail = function () {
        return (_.includes($scope.viewModel.permissions, authorizationConstants.AUTHORIZATION_EMAIL_DELETE_EMAIL));
    };

    $scope.canCreateAttachment = function () {
        return (_.includes($scope.viewModel.permissions, authorizationConstants.AUTHORIZATION_ADD_ATTACHMENTS));
    };

    $scope.canUserCreateAttachment = function () {
        if ($scope.isUnderwriterUser()) {
            return $scope.canCreateAttachment() && !$scope.viewModel.enableFileFromTemplate;
        } else {
            return $scope.canCreateAttachment();
        }
    };

    $scope.isShared = function (item) {
        return !_.isNil(item) && !$scope.isEmailDraft(item) && $scope.isUnderwriterUser() && (item.summaryData.shared || item.summaryData.publicNote);
    };

    $scope.getPriorityLabel = function (key) {
        return $scope.i18n.task.priority[key];
    };

    $scope.onPrintCollab = function () {
        $state.go('submission.printCollaboration', {
            submissionId: $stateParams.submissionId,
            formId: $stateParams.formId,
            collabType: $scope.viewModel.filterType
        }, { reload: true });
    };

    $scope.onRefreshCollabAttachments = function () {
        $scope.viewModel.isLoading = true;
        collaborationMediator.refreshCollaborationAttachments($stateParams.submissionId).finally(function () {
            $scope.viewModel.isLoading = false;
        })
    };

    $scope.canCreateAttachmentFromTemplate = function () {
        return $scope.canCreateAttachment() && $scope.isUnderwriterUser() && $scope.viewModel.enableFileFromTemplate;
    };

    $scope.isUnderwriterUser = function () {
        return $scope.viewModel.userType === 'Underwriter' || $scope.viewModel.userType === 'ServiceUser';
    };

    $scope.canInviteMembers = function () {
        return $scope.isUnderwriterUser() && $scope.canCreateChat();
    };

    $scope.canHideEmail = function () {
        return (_.includes($scope.viewModel.permissions, authorizationConstants.AUTHORIZATION_HIDE_SHARED_EMAIL));
    };

    $scope.onClearSearchInput = function () {
        $scope.viewModel.searchInput = '';
        $scope.onSearchInputChange();
    };

    $scope.hideAllSharedItem = function () {
        modalUtil.showConfirmationModal(null, null/*quoteId*/, null/*notificationName*/, 'submission.collaboration.hideCollaborationModal', '', /*hideLoadingBar*/false, handleClose);

        function handleClose() {
            return collaborationMediator.hideAllSharedCollaborationItem($stateParams.submissionId).then(function () {
                $scope.viewModel.showGearIcon = false;
            });
        }
    };

    // When this is invoked via the ng-change, it has already bee automatically debounced via ng-model-options.
    $scope.onSearchInputChange = function () {
        loadCollaborationItems();
    };

    $scope.$on(submissionConstant.event.CLOSE_COLLABORATION, function () {
        closeDrawer();
    });

    $scope.$on(submissionConstant.event.TOGGLE_COLLABORATION, function () {
        $scope.onToggleCollaboration();
    });

    $scope.$on(submissionConstant.event.CREATE_COLLABORATION_ITEM_MESSAGE, function (event, collaborationItem) {
        timeoutList.push($timeout(function () {
            $scope.viewModel.collabItemList.push(collaborationItem);

            processCollaborationItems();
        }, 0));
    });

    $scope.$on(submissionConstant.event.UPDATE_COLLABORATION_ITEM_MESSAGE, function (event, collaborationItem) {
        let removed = false,
            index;

        // Remove this item if we get an update about unsharing.
        if (!$scope.viewModel.hasSharedPermission && !_.isNil(collaborationItem.summaryData)) {
            if ((!collaborationItem.summaryData.publicNote && !collaborationItem.summaryData.shared) || collaborationItem.summaryData.published === false) {
                removed = true;
                timeoutList.push($timeout(function () {
                    _.remove($scope.viewModel.collabItemList, function (collabItem) {
                        return collabItem.uri === collaborationItem.uri;
                    });
                }, 0));
            }
        }

        // Remove this item if it was a chat message update with the 'published' bit set to false.
        if (collaborationItem.type === 'message' && !_.isNil(collaborationItem.summaryData)) {
            if (collaborationItem.summaryData.published === false) {
                removed = true;
                timeoutList.push($timeout(function () {
                    _.remove($scope.viewModel.collabItemList, function (collabItem) {
                        return collabItem.uri === collaborationItem.uri;
                    });
                }, 0));
            }
        }

        if (!removed) {
            timeoutList.push($timeout(function () {
                if (collaborationItem.type === 'note') {
                    collaborationItem.summaryData.snippet = generateNoteSnippet(collaborationItem);
                    collaborationItem.summaryData.note = collaborationItem.summaryData.note;
                }

                // The index of the collaboration item needs to be defined within this function as the $scope.viewModel.collabItemList can update by the time this function is invoked
                // e.g. when a new attachment is added to a draft email, two collaboration items are created; one for the updated email and the second for the new attachment
                index = _.findIndex($scope.viewModel.collabItemList, function (collabItem) {
                    return collabItem.uri === collaborationItem.uri;
                });

                if (index !== -1) {
                    $scope.viewModel.collabItemList.splice(index, 1, collaborationItem);
                } else {
                    $scope.viewModel.collabItemList.push(collaborationItem);

                }
            }, 0));
        }

        timeoutList.push($timeout(function () {
            processCollaborationItems();
        }, 0));
    });

    $scope.$on(submissionConstant.event.DELETE_COLLABORATION_ITEM_MESSAGE, function (event, collaborationItem) {
        timeoutList.push($timeout(function () {
            _.remove($scope.viewModel.collabItemList, function (collabItem) {
                return collabItem.uri === collaborationItem.uri;
            });

            processCollaborationItems();
        }, 0));
    });

    $scope.$on(submissionConstant.event.OPEN_CHAT_COLLABORATION, function () {
        openDrawer();
        $scope.openChat();
    });


    $scope.$on(coreConstant.event.MULTI_SELECT_UPDATED, function (event, itemName) {
        if (itemName === $scope.viewModel.filterListItemName) {
            $scope.viewModel.selectedFilterList = [];

            _.each($scope.viewModel.filterList, function (item) {
                if (item.selected) {
                    $scope.viewModel.selectedFilterList.push(item);
                }
            });

            $scope.viewModel.isFilterOn = $scope.viewModel.selectedFilterList.length > 0;
            filterItem();
        }
    });

    $scope.$on('$destroy', function () {
        _.each(timeoutList, function (item) {
            $timeout.cancel(item);
        });
    });

    restoreState();
    loadProfileInfo();
    loadCollaborationItems();
    getFileTemplates();
    getEmailTemplates();
};

angular.module('gw-um-submission')
    .controller('collaborationController', CollaborationController);
